import get from "lodash/get";
import throttle from "lodash/throttle";
import React, { forwardRef, useEffect, useMemo } from "react";
import { v4 as uuid } from "uuid";
import OverlaysContext from "./overlaysContext";
import { hidePopoverOverlays as overlaysManagerHidePopoverOverlays } from "./overlaysManager";
export default function withOverlaysProvider(Comp, overlaysContainerId) {
    function WithOverlaysProvider(props) {
        const overlaysManager = useMemo(() => `overlaysManager_${uuid()}`, []);
        const hidePopoverOverlays = () => {
            overlaysManagerHidePopoverOverlays(overlaysManager);
        };
        useEffect(() => {
            const handleScroll = throttle(hidePopoverOverlays, 500);
            window.addEventListener("scroll", handleScroll);
            return () => {
                window.removeEventListener("scroll", handleScroll);
            };
        }, []);
        const { forwardedRef, context, ...other } = props;
        const providerValue = useMemo(() => ({
            overlaysContainerId: overlaysContainerId || get(context || {}, "overlaysContainerId"),
            overlaysManager
        }), [context]);
        return (React.createElement(OverlaysContext.Provider, { value: providerValue },
            React.createElement(Comp, { ref: forwardedRef, ...other, hidePopoverOverlays: hidePopoverOverlays })));
    }
    const ForwardedWithOverlaysProvider = forwardRef((props, ref) => (React.createElement(OverlaysContext.Consumer, null, context => (React.createElement(WithOverlaysProvider, { ...props, context: context, forwardedRef: ref })))));
    ForwardedWithOverlaysProvider.displayName = `forwardedWithOverlaysProvider(${get(Comp, "displayName", "")})`;
    return ForwardedWithOverlaysProvider;
}
